/* eslint-disable @typescript-eslint/no-floating-promises */
import { useMutation, useQueryClient } from 'react-query';
import { dataSelector } from '@nextiva/global-store';
import { useSelector } from 'react-redux';

import { saveConsentGrantStatus } from 'services/consentGrantStatus/consentGrantStatusService';
import { GlobalStoreInterface } from 'interface/globalStore';

export const useSaveConsentGrantStatus = () => {
  const globalStoreData: GlobalStoreInterface | undefined = useSelector(
    dataSelector,
  );
  const queryClient = useQueryClient();

  return useMutation(
    ['consentGrantStatus', globalStoreData.sso],
    () =>
      saveConsentGrantStatus(
        globalStoreData.sso,
        String(globalStoreData?.user?.accountInfo?.corpAcctNbr),
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('consentGrantStatus');
      },
    },
  );
};
